import React from 'react';
import { Toolbar } from '@mui/material';
import NewNavbar from '../../components/Navbar/New/Navbar';
import { Container } from 'react-bootstrap';
import FloatingButton from '../../components/elements/Floating-Button';

const NewLayout = ({ children }) => {
  return (
    <Container fluid className="px-0">
      <NewNavbar />
      <div
        component="main"
        style={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}>
        <Toolbar />
        <div
          style={{
            flexGrow: 1,
            padding: '16px',
          }}>
          {children}
        </div>
        <FloatingButton />
      </div>
    </Container>
  );
};

export default NewLayout;
